//
// Copyright (c) 2019-Present Syncari - All rights reserved.
//
import { Steps as ASteps } from 'antd';

import { useSkullConfigContext } from 'components/skull';
import InsightsWizardSteps from 'pages/insights-studio/components/InsightsWizardSteps';

import './ConfigSteps.less';

const { Step: AStep } = ASteps;

export interface ConfigStepsProps {
  direction?: string;
}

const ConfigSteps = ({ direction }: ConfigStepsProps) => {
  const { steps, currentStep } = useSkullConfigContext();

  return direction === 'vertical' ? (
    <InsightsWizardSteps steps={steps.map((s) => s.stepName)} currentStep={currentStep} />
  ) : (
    <div className="synri-config-steps-container">
      <ASteps current={currentStep}>
        {steps.map((step) => (
          <AStep title={step.stepName} key={`config-steps-${step.stepName}`} />
        ))}
      </ASteps>
    </div>
  );
};

export default ConfigSteps;
